<template>
  <v-card class="w-100 pa-5 px-16" dir="ltr">
    <v-row>
      <v-col v-for="key in keys" :key="key" cols="2">
        <div class="flex-col-start-start">
          <div class="flex-row-start-center gap-2">
            <div class="text-body-2 mainBlue--text">
              {{ key === "interval" ? "Interval" : $t(key) }}:
            </div>
            <div class="text-body-2 text--text">
              <div v-if="key === 'interval'">
                {{ predictionData[key] }} hours
              </div>
              <div v-else>{{ predictionData[key] }}%</div>
            </div>
          </div>
          <small
            v-if="key === 'carbon' && predictionData.errorRateCarbon != null"
          >
            ({{ $t("error_rate") }}: %{{ predictionData.errorRateCarbon }})
          </small>
          <small
            v-if="
              key === 'metallization' && predictionData.errorRateMetal != null
            "
          >
            ({{ $t("error_rate") }}: %{{ predictionData.errorRateMetal }})
          </small>
        </div>
      </v-col>
      <v-col cols="6" dir="rtl">
        <div class="flex-row-start-center gap-2">
          <div class="text-body-2 text--text">{{ $t("dateTime") }}:</div>
          <div class="text-body-2 text--text">
            {{ time }}
          </div>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import moment from "jalali-moment";

export default {
  name: "PredictionHistoryCard",

  props: {
    predictionData: { type: Object, required: true },
  },

  data() {
    return {
      keys: ["carbon", "metallization", "interval"],
    };
  },

  computed: {
    time() {
      return moment(this.predictionData.time).format("jDD jMMMM jYYYY - hh:mm");
    },
  },
};
</script>
